import { render, staticRenderFns } from "./UsersMaintenanceComponent.vue?vue&type=template&id=28eef3f2&scoped=true"
import script from "./UsersMaintenanceComponent.vue?vue&type=script&lang=js"
export * from "./UsersMaintenanceComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eef3f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28eef3f2')) {
      api.createRecord('28eef3f2', component.options)
    } else {
      api.reload('28eef3f2', component.options)
    }
    module.hot.accept("./UsersMaintenanceComponent.vue?vue&type=template&id=28eef3f2&scoped=true", function () {
      api.rerender('28eef3f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/somos1/UsersMaintenanceComponent.vue"
export default component.exports